
















































import {
	defineComponent,
	computed,
	PropType,
	watch,
} from '@vue/composition-api';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SearchOrganizations from '@front-app/modules/organization/components/SearchOrganizations.vue';
import TrAddress from '@front-app/components/TrAddress.vue';
import { CommunityWithGroups, UpdateCommunityOrganizationRequest } from '@front-app/services/CommunityApi/CommunityModel';
import { FocusableElement } from '@front-app/hooks/useAsyncModal';
import { OrganizationsStore } from '@front-app/store/singletons/Organizations';
import { PartialOrganization } from '@front-app/services/OrganizationsApi/OrganizationModel';
import { SearchOption } from '@front-app/components/search/useSearch';
import { Spacing } from '@front-app/components/constants';
import { useAsyncStatus } from '@front-app/hooks/useAsyncStatus';
import { useCommunitiesStore } from '@front-app/store/piniaModules/communities';

export default defineComponent({
	components: {
		ErrorCard,
		SearchOrganizations,
		TrAddress,
	},
	props: {
		community: {
			type: Object as PropType<CommunityWithGroups>,
			required: false,
			default: null,
		},
	},
	setup(props, ctx) {
		const communitiesStore = useCommunitiesStore();

		watch(() => props.community.id, async (curr, prev) => {
			if (curr !== prev) {
				await OrganizationsStore.fetchAllPartial();
			}
		}, { immediate: true });

		const {
			allPartial: organizations,
			isLoadingAllPartial: isLoadingOrganizations,
		} = OrganizationsStore;

		const {
			track,
			clear,
			isError: isErrorUpdatingOrganization,
			isSuccess: isSuccessUpdatingOrganization,
		} = useAsyncStatus();

		const updateOrganization = async (result: SearchOption<PartialOrganization>, returnTo: FocusableElement) => {
			const payload: UpdateCommunityOrganizationRequest = {
				organizationId: result.original.id,
			};
			await track(communitiesStore.saveOrganization(props.community.id, payload));

			returnTo.focus();
			clear(4000);

			if (isSuccessUpdatingOrganization.value) {
				ctx.emit('close');
			}
		};
		const currentLogoSrc = computed(() => {
			const { logoSrc } = props.community.organization;
			// Extra variable is needed here, or else the env var is not properly interpolated for some reason 🤷‍♀️
			const baseUrl = process.env.VUE_APP_TRAPP_PUBLIC_URL;
			return logoSrc ? `${baseUrl}${logoSrc}.png` : '';
		});

		return {
			currentLogoSrc,
			isLoadingOrganizations,
			organizations,
			updateOrganization,
			isErrorUpdatingOrganization,
			isSuccessUpdatingOrganization,
			// Util
			Spacing,
		};
	},
});
